import React, { useState } from 'react'
import { Col, Image, Button, Modal, Container, Row, Form } from 'react-bootstrap';
import ResumeTempOne from '../../assets/image/resume_temp_1.png';
import ResumeTempTwo from '../../assets/image/resume_temp_2.png';
import { setItem, getItem } from '../../config/localStorage';


function ChangeTemplateLayout() {
    const defaultTempType = '1';
    const chossenTempType = getItem('choosenTemplateType');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [tempImage, setTempImage] = useState(chossenTempType ?? defaultTempType);

    const [choosenTemplate, setChoosenTemplate] = useState(tempImage);

    const ChangeTemplateOption = (e) => {
        setChoosenTemplate(e.target.value);
    }

    const handleSubmit = () => {
        const selectedValue = document.querySelector('input[name="template-option"]:checked').value;
        setItem('choosenTemplateType', selectedValue);
        setTempImage(selectedValue);
        handleClose();
    }

    return (
        <>
            <Col md={12}>
                <Image src={tempImage === '1' ? ResumeTempOne : ResumeTempTwo} alt="template-image" className='w-100 dis-temp-image' />
                <Button className='my-previous-btn w-100 mt-3 mb-3' onClick={handleShow}>Change template</Button>
            </Col>

            <Modal
                dialogClassName="cust-large-modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                backdrop='static'
                show={show} onHide={handleClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Choose your template
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col md={12} className='res-cut-outer'>
                                <Form className='choose-template-form'>
                                    <div className="image_radio_button_control">
                                        <label className={`radio-button-label ${ choosenTemplate === '1' ? 'show' : ''}`} >
                                            <input
                                                type="radio"
                                                name="template-option"
                                                defaultValue="1"
                                                onClick={ChangeTemplateOption}
                                                defaultChecked={tempImage === "1"}
                                            />
                                            <Image src={ResumeTempOne} alt="template-image" className='w-100' />
                                        </label>
                                        <label className={`radio-button-label ${ choosenTemplate === '2' ? 'show' : ''}`} >
                                            <input
                                                type="radio"
                                                name="template-option"
                                                defaultValue="2"
                                                onClick={ChangeTemplateOption}
                                                defaultChecked={tempImage === "2"}
                                            />
                                            <Image src={ResumeTempTwo} alt="template-image" className='w-100' />
                                        </label>
                                    </div>
                                </Form>
                            </Col>
                            <Modal.Footer className='mt-4'>
                                <Button className='button-green' type="submit" onClick={handleSubmit}>Save changes</Button>
                            </Modal.Footer>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </>

    )
}

export default ChangeTemplateLayout;